export const moduleId = 'account-info';
import accontInfoApi from "@/api/account-info/index";
import UserPersistence from "@/persistence/UserPersistence";
export const state = {


  pageFlag: 'list',  //list add edit  allocation  分配

  enumerationList: [],
  routerKey: 0

};
export const actions = {
  async getEnumerationList({ commit }) {
    const { data, code } = await accontInfoApi.getAllEnumeration()
    if (code === 0) {
      commit('setEnumerationList', data)
    }
  }




};
export const mutations = {
  setPageFlag(state, data) {
    state.pageFlag = data

  },

  //存储枚举
  setEnumerationList(state, list) {
    state.enumerationList = list
    UserPersistence.saveEnumerationList(JSON.stringify(list))
  },
  setRouterKey(state) {
    state.routerKey++
  }


}

export const getters = {}
export default {
  state: state,
  actions: actions,
  mutations: mutations,
  getters: getters
}



// WEBPACK FOOTER //
// ./src/store/modules/account-info/index.js